import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameServices } from '../../services/game-services';

export class LoadingCellViewModel {
  public get cellColor() {
    return 0xffffff;
  }

  public get cellAlpha() {
    const rowStripe = this.row < 3 || this.row > 5;
    const colStripe = this.column < 3 || this.column > 5;
    return (rowStripe && colStripe) || (!rowStripe && !colStripe) ? 0.1 : 0.2;
  }

  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }

  constructor(
    private gameServices: GameServices,
    readonly row: number,
    readonly column: number,
  ) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }
}
